<template>
    <div class="flexible-packaging-page">
        <flexible-packaging-header></flexible-packaging-header>
        <div style="background: #F5F5F5;" ref="start-pos">
            <div v-if="store.currentStep < 6">
                <div class="spacer-112"></div>
                <flexible-packaging-navigation></flexible-packaging-navigation>
                <div class="spacer-64"></div>
            </div>

            <div>
                <component :is="store.steps[store.currentStep].component" class="fade-in"></component>
            </div>

            <div class="spacer-112"></div>
        </div>

        <div class="spacer-128"></div>
    </div>
</template>

<script>
import FlexiblePackagingNavigation from "./sub/FlexiblePackagingNavigation";
import {useFlexiblePackagingStore} from "./js/store";
import FlexiblePackagingCategorySelector from "./sub/steps/FlexiblePackagingCategorySelector";
import FlexiblePackagingPouchTypeSelector from "./sub/steps/FlexiblePackagingPouchTypeSelector";
import FlexiblePackagingQuestionnaire from "./sub/questionnaire/FlexiblePackagingQuestionnaire";
import FlexiblePackagingSku from "./sub/steps/FlexiblePackagingSku";
import { ref, watch } from 'vue';
import FlexiblePackagingFileUpload from "./sub/steps/FlexiblePackagingFileUpload";
import FlexiblePackagingDetailForm from "./sub/steps/FlexiblePackagingDetailForm";
import FlexiblePackagingSummary from "./sub/steps/FlexiblePackagingSummary";
import FlexiblePackagingUnwindSelector from "./sub/steps/FlexiblePackagingUnwindSelector";
import {validateAllStepsTill} from "./js/validation";
import FlexiblePackagingHeader from "./sub/FlexiblePackagingHeader";
import FlexiblePackagingQuerySent from "./sub/steps/FlexiblePackagingQuerySent";

export default {
    components: {
        FlexiblePackagingQuerySent,
        FlexiblePackagingHeader,
        FlexiblePackagingUnwindSelector,
        FlexiblePackagingSummary,
        FlexiblePackagingDetailForm,
        FlexiblePackagingFileUpload,
        FlexiblePackagingSku,
        FlexiblePackagingQuestionnaire,
        FlexiblePackagingPouchTypeSelector, FlexiblePackagingNavigation, FlexiblePackagingCategorySelector},
    setup() {
        const store = useFlexiblePackagingStore();

        return {
            store: store,
        }
    },
    mounted() {
        let app = this;
        watch(() => this.store.data.category, () => {
            switch (app.store.data.category) {
                case 'rollstock':
                    app.store.steps[1].component = 'FlexiblePackagingUnwindSelector';
                    app.store.steps[2].enabled = false;

                    if (app.store.data.unwind === null) {
                        app.store.data.unwind = 'left_first';
                    }
                    break;
                default:
                    app.store.steps[1].component = 'FlexiblePackagingPouchTypeSelector';
                    app.store.steps[2].enabled = true;
                    app.store.data.unwind = null;
            }
        });

        watch(() => this.store.currentStep, (oldValue, newValue) => {
            this.scrollToStart();

            if (!app.store.steps[this.store.currentStep].enabled) {
                this.store.currentStep=oldValue > newValue ? this.store.currentStep+1: this.store.currentStep-1;
            }
        });
    },
    methods: {
        scrollToStart() {
            if (this.store.currentStep === 2) {
                return;
            }

            let element = this.$refs["start-pos"];
            window.$scrollToElement({element, offset: 0})
        }
    }
}
</script>
